import { PORTAL_ROLES } from '@/authorization/authorization.constants';
import { getUserPortalRole } from '@/core/web-storage/webStorage.utils';
import { getBoardId } from '@/core/web-storage/webStorage.utils';

export function isEmployerUser(portalRole: PORTAL_ROLES): boolean {
  return portalRole === PORTAL_ROLES.EMPLOYER_USER || portalRole === PORTAL_ROLES.EMPLOYER_ADMIN;
}

export function isSandboxBoard() {
  const userBoardId = Number(getBoardId());
  return userBoardId >= 900 && userBoardId <= 999;
}

export function isAtrfSandbox() {
  const userPortalRole = getUserPortalRole();
  return userPortalRole === PORTAL_ROLES.ATRF && isSandboxBoard();
}

export function isValidPortalRole(portalRole: string) {
  const portalRoles = [
    PORTAL_ROLES.EMPLOYER_USER,
    PORTAL_ROLES.EMPLOYER_ADMIN,
    PORTAL_ROLES.ATRF,
    PORTAL_ROLES.ATA,
  ] as string[];
  return portalRole && portalRoles.includes(portalRole);
}
